import React, { useContext } from 'react';
import {
  Appbar, Card, IconButton,
} from 'react-native-paper';
import { useMutation, useQuery } from '@apollo/client';
import { ScrollView, View } from 'native-base';
import { useToast } from 'react-native-toast-notifications';
import TransportationVisualizer from '../../components/transportation/TransportationVisualizer';
import { GET_TRANSPORTATIONS } from '../../gql/transportation/query';
import { ModalContext } from '../../context/ModalContext';
import ManageTransportationModal from '../../modals/ManageTransportation/ManageTransportation';
import RefreshableScreen from '../Refreshable/RefreshableScreen';
import LoadingIndicator from '../../components/commons/LoadingIndicator';
import { DELETE_TRANSPORTATION } from '../../gql/transportation/mutation';

function ManageTransportations() {
  const toast = useToast();
  const {
    displayManageTransportationModal,
    toggleManageTransportationModal,
  } = useContext(ModalContext);

  const { data, loading, refetch } = useQuery(GET_TRANSPORTATIONS);

  const [deleteTransportation, { error: deleteError }] = useMutation(DELETE_TRANSPORTATION, {
    onCompleted: (_data) => {
      toast.show(`Transport ${_data.deleteTransportation.id} supprimé avec succès.`);
      refetch();
    },
    refetchQueries: [{ query: GET_TRANSPORTATIONS }],
  });

  if (deleteError) toast.show(deleteError.message);

  const handleCreate = () => {
    toggleManageTransportationModal({
      title: 'Créer un nouveau transport',
      onSave: refetch,
    });
  };

  return (
    <>
      <Appbar.Header statusBarHeight={0}>
        <View style={{ flexDirection: 'column', width: '100%' }}>
          <View style={{
            flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 16,
          }}
          >
            <Appbar.Content title="Gérer les transports" />
            <Appbar.Action
              icon="plus"
              onPress={handleCreate}
            />
          </View>
        </View>
      </Appbar.Header>
      <RefreshableScreen onRefresh={async () => {
        await refetch();
      }}
      >
        {loading && <LoadingIndicator text="Chargement des transports..." />}
        {displayManageTransportationModal.display && <ManageTransportationModal />}

        <ScrollView>
          {data?.transportations?.map((d) => (
            <Card key={d.id} style={{ margin: 8 }}>
              <Card.Title title={d.name} subtitle={`Type: ${d.type} - Sièges: ${d.seats}`} />
              <Card.Content>
                <TransportationVisualizer type={d.type} seats={d.seats} color={d.color} />
              </Card.Content>
              <Card.Actions>
                <IconButton
                  icon="application-edit"
                  onPress={() => toggleManageTransportationModal({
                    title: 'Modifier le transport',
                    transportation: d,
                    onSave: refetch,
                  })}
                />
                <IconButton
                  icon="delete"
                  onPress={() => deleteTransportation(
                    {
                      variables: { id: Number(d.id) },
                    },
                  )}
                />
              </Card.Actions>
            </Card>
          ))}
        </ScrollView>
      </RefreshableScreen>
    </>
  );
}

export default ManageTransportations;
